export enum OptionStatus {
  NOT_CHOSEN,
  NOT_CHOSEN_CORRECT,
  CHOSEN_CORRECT,
  CHOSEN_INCORRECT,
}
export const OptionStatusToColour: Record<OptionStatus, string> = {
  [OptionStatus.NOT_CHOSEN]: 'lightGray',
  [OptionStatus.NOT_CHOSEN_CORRECT]: '#2EB67D',
  [OptionStatus.CHOSEN_CORRECT]: '#2EB67D',
  [OptionStatus.CHOSEN_INCORRECT]: '#FF485F',
};
